// extracted by mini-css-extract-plugin
export var borderRadius = "_ap-4";
export var large = "_ap-3";
export var logoContainer = "_ap-0";
export var nameLogo = "_ap-2";
export var small = "_ap-1";